export default {
  sourcing: {
    nav: 'Sourcing',
    title: 'Активный поиск',
    subtitle: 'LinkedIn-кандидаты через Apify: поиск, оценка потенциала, outreach',
    newProject: 'Новый проект',
    projectName: 'Название проекта',
    language: 'Язык проекта',
    vacancy: 'Вакансия (для promote)',
    noVacancy: 'Без вакансии',
    portrait: 'Портрет кандидата (кого ищем)',
    outreachTemplate: 'Шаблон outreach-сообщения ({{name}} — имя кандидата)',
    candidates: 'кандидатов',
    scored: 'оценено',
    create: 'Создать',
    cancel: 'Отмена',
    save: 'Сохранить',
    close: 'Закрыть',
    loading: 'Загрузка…',
    empty: 'Пока пусто',
    error: 'Ошибка',
    back: 'Назад',
    all: 'Все',

    runs: 'Запуски',
    newRun: 'Новый запуск',
    importFile: 'Импорт из файла',
    importRun: 'Импортировать результат',
    exportCsv: 'Экспорт CSV',
    scoreAll: 'Оценить всех (AI)',
    scoringInProgress: 'Оценка идёт — это может занять несколько минут…',
    scoredResult: 'Оценено: {{scored}}, ошибок: {{failed}}',
    importedResult: 'Импортировано: {{imported}}, дубликатов: {{duplicates}}',
    runStatus: { queued: 'в очереди', running: 'выполняется', succeeded: 'завершён', failed: 'ошибка' },

    filterGrade: 'Грейд',
    filterBucket: 'Bucket',
    filterStatus: 'Статус',
    minScore: 'Мин. балл',
    search: 'Поиск: имя, компания, титул…',

    colName: 'Кандидат',
    colRole: 'Роль и компания',
    colYears: 'Лет',
    colFlags: 'Флаги',
    colScore: 'Балл',
    colGrade: 'Грейд',
    colStatus: 'Статус',
    flagFounder: 'экс-основатель',
    flagFastGrowth: 'быстрый рост',
    flagRussian: 'русский язык',
    flagOpenToWork: 'open to work',
    promoted: 'в pipeline',
    markContacted: 'Отметить contacted ({{count}})',

    status: {
      found: 'найден',
      reviewed: 'просмотрен',
      contacted: 'написали',
      replied: 'ответил',
      interested: 'заинтересован',
      questionnaire: 'анкета',
      case: 'кейс',
      interview: 'интервью',
      finalist: 'финалист',
      offer: 'оффер',
      rejected: 'отказ',
      no_response: 'нет ответа',
    },

    profile: 'Профиль',
    about: 'О себе',
    experience: 'Опыт',
    education: 'Образование',
    skills: 'Навыки',
    languages: 'Языки',
    connections: 'контактов',
    assessment: 'Оценка потенциала',
    notScored: 'Ещё не оценён',
    scoreNow: 'Оценить (AI)',
    evidence: 'Факты',
    assumptions: 'Допущения',
    unknowns: 'Неизвестно',
    criteriaLabels: {
      entrepreneurial_drive: 'Предпринимательская жилка',
      ownership_initiative: 'Ответственность и инициатива',
      commercial_instinct: 'Коммерческое чутьё',
      analytical_ability: 'Аналитические способности',
      uae_market_knowledge: 'Знание рынка ОАЭ',
      leadership_potential: 'Лидерский потенциал',
      bias_to_action: 'Ориентация на действие',
      calculated_risk: 'Взвешенный риск',
      career_hunger: 'Карьерный голод',
    },
    requiredQuestions: 'Вопросы кандидату',
    summary: 'Резюме для собственника',
    redFlags: 'Красные флаги',
    manualGrade: 'Ручной грейд',
    outreachStatus: 'Статус outreach',
    channel: 'Канал',
    notes: 'Заметки',
    copyOutreach: 'Скопировать outreach-сообщение',
    copied: 'Скопировано',
    noTemplate: 'В проекте не задан шаблон сообщения',
    promote: 'Promote в вакансию',
    promoteConfirm: 'Создать кандидата в вакансии? Дальше — анкеты, письма и интервью как обычно.',
    selectVacancy: 'Выберите вакансию',
    promotedOk: 'Кандидат создан в pipeline',

    preset: 'Пресет',
    customInput: 'Свой input',
    inputJson: 'Input для актёра (JSON)',
    bucket: 'Bucket',
    estCost: 'Ожидаемая стоимость',
    estCostFormula: '$0.10 × страниц + $0.004 × maxItems',
    start: 'Запустить',
    starting: 'Запускаем…',
    invalidJson: 'Некорректный JSON',
    runStarted: 'Запуск создан — статус обновляется на странице проекта',
  },
};
